'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var home = exports.home = {
  title: 'Learn to be <b>better</b>',
  description: 'Practical video training for everything you need',
  whatis_title: 'What is Tutellus?',
  whatis_description: 'Tutellus is the leading online collaborative EdTech platform in the Spanish-speaking world. With thousands of video courses and around one million users, you can use Tutelus in three ways;',
  t_learn_title: 'Learn',
  t_learn_description: 'As a student, you can always find something new to learn among thousands of courses',
  t_teach_title: 'Teach',
  t_teach_description: 'Show your teaching skills and monetize your knowledge by becoming a teacher',
  t_promote_title: 'Promote',
  t_promote_description: 'Promote courses created by other users and make money as an Affiliate. It is that easy!',
  learn_title: 'Learn from thousands of courses',
  learn_description: 'Find what you need among over 100,000 video courses, of all topics and levels. Learn at your own pace with a great product designed to give you control over your own learning process.',
  improve_title: 'Improve your professional career',
  improve_description: 'In addition to courses, the Subscription service allows you to sign up for as many Careers as you would like, for a fixed amount of money. Over 30 Careers are available, with learning paths and tutors.',
  students_title: 'Over 3 million users in 160 countries',
  students_description: 'Your neighbor will probably be using Tutellus, even if you do not know it :) Join us and become a part of the educational revolution.',
  register_title: 'Register now, it is free and you will gain access to all the knowledge of the world.',
  register_cta: 'REGISTER'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/home.js
// module id = 716
// module chunks = 0